import { INPUT_TYPES } from '../utils/constants';
import { default as GALLERY_CONSTS } from '../../common/constants';
import { createOptions } from '../utils/utils';
export default {
    title: 'Scroll Direction',
    isRelevant: function () { return true; },
    isRelevantDescription: 'Always relevant.',
    type: INPUT_TYPES.OPTIONS,
    default: GALLERY_CONSTS.scrollDirection.VERTICAL,
    options: createOptions('scrollDirection'),
    description: "Toggle between two types of galleries. Vertical and Horizontal. Notice that many options are available only for a specific scroll direction.",
};
//# sourceMappingURL=scrollDirection.js.map